// extracted by mini-css-extract-plugin
export default {"root":"nkdebbvmL4","spinner":"OWf7X4iPK8","root_small":"y4JdhavtzK","root_inline":"dL9AsirbYs","root_white":"UCc1hmkPM0"};